(function () {
  var STORAGE_KEY = 'xhenStickyShippingBarDismissed';
  var bar = document.getElementById('xhen-sticky-shipping-bar');
  if (!bar) return;

  var dismissed = false;
  try {
    dismissed = window.sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch (e) {
    dismissed = false;
  }

  if (dismissed) {
    bar.remove();
    document.documentElement.style.setProperty('--xhen-sticky-shipping-bar-height', '0px');
    return;
  }

  function setBarHeightVar() {
    document.documentElement.style.setProperty('--xhen-sticky-shipping-bar-height', bar.offsetHeight + 'px');
  }

  setBarHeightVar();
  window.addEventListener('resize', setBarHeightVar);

  var closeButton = document.getElementById('xhen-sticky-shipping-bar-close');
  if (closeButton) {
    closeButton.addEventListener('click', function () {
      bar.remove();
      document.documentElement.style.setProperty('--xhen-sticky-shipping-bar-height', '0px');
      try {
        window.sessionStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {
        /* sessionStorage unavailable, ignore */
      }
    });
  }
})();
